module.exports = __webpack_public_path__ + "arrive_straight.svg?e0c08eba7d32a1841ed2d9f6b380e7a2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/arrive_straight.svg
// module id = 148
// module chunks = 0